// Authentication guard for protected routes - redirects to signin if not authenticated
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store';
import { getDefaultGuestSignInPath } from '@utils/routing';
import { Spin } from 'antd';
import { Spinner } from '@/pages/style';

const RequireAuth = ({ children }) => {
    const user = useAuthStore((state) => state.user);
    const isRefreshing = useAuthStore((state) => state.isRefreshing);
    const location = useLocation();

    if (isRefreshing) {
        return <Spinner><Spin size="large" /></Spinner>;
    }

    if (!user) {
        return <Navigate to={getDefaultGuestSignInPath()} state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;

